import { FC } from 'react';
import { Link } from '@remix-run/react';
import clsx from 'clsx';
import styles from './Tab.module.css';
import { useTab, Props } from './useTab';

export const Tab: FC<Props> = (props) => {
  const { items } = useTab(props);

  return (
    <div className={styles.tab}>
      <ul className={styles.list}>
        {items.map((item, i) => {
          return (
            <li className={styles.item} key={i}>
              {item.to &&
              <Link
                to={item.to}
                className={clsx(styles.link, item.active && styles.active)}>

                  {item.name}
                </Link>}

              {!item.to && item.name}
            </li>);

        })}
      </ul>
    </div>);

};